module.exports = __webpack_public_path__ + "static/media/place-icon.24878e34.svg";